import { createElement } from 'react';
import classNames from '@/utils/classNames';

import type { ComponentProps } from 'react';

const CLASSNAME =
  'bg-transparent focus-visible:outline-stone-600 shadow-none flex justify-center items-center cursor-pointer group hover:bg-stone-600/20 text-greyscale-900/60 hover:text-greyscale-900 p-1 h-6 w-6 rounded-sm mx-1 hover:shadow';

export type IconButtonProps = {
  className?: string;
  as?: 'button' | React.ReactNode;
} & ComponentProps<'button'>;

const IconButton = ({
  as = 'button',
  className,
  ref,
  ...props
}: IconButtonProps) =>
  createElement(
    // @ts-expect-error
    as,
    {
      ref,
      className: classNames(CLASSNAME, className),
      ...props,
    },
  );

IconButton.displayName = 'IconButton';

export default IconButton;
